/* Contact form conditional fields.
 *
 * Reproduces the reference behaviour (app/contact/ContactForm.tsx):
 *   1. Choosing a department reveals the rest of the form.
 *   2. Three of six departments also reveal an Order Number field.
 *
 * This is progressive enhancement, not a dependency. Without JavaScript the
 * whole form is visible and submits normally. That is deliberately better than
 * the reference, whose mailto: form does not work at all for anyone without a
 * configured desktop mail client.
 *
 * Respects prefers-reduced-motion for the reveal transition.
 */
(function () {
  'use strict';

  var FORM_ID = 'vdps-form-contact';

  function init() {
    var wrap = document.getElementById(FORM_ID);
    if (!wrap) return;

    var select = wrap.querySelector('select[name="contact[department]"]');
    if (!select) return;

    // Departments that should show the order-number field. Read from a JSON
    // config block so the list lives in one place (the page template).
    var orderDepts = [];
    var cfgEl = document.getElementById('vdps-contact-config');
    if (cfgEl) {
      try {
        orderDepts = (JSON.parse(cfgEl.textContent) || {}).orderNumberDepartments || [];
      } catch (e) {
        // Malformed config must not break the form; fall back to showing all.
        orderDepts = [];
      }
    }

    var fields = Array.prototype.slice.call(
      wrap.querySelectorAll('.vdps-form__field')
    );
    var actions = wrap.querySelector('.vdps-form__actions');

    var departmentField = select.closest('.vdps-form__field');
    var orderField = wrap.querySelector('input[name="contact[order_number]"]');
    var orderWrap = orderField ? orderField.closest('.vdps-form__field') : null;

    // Anything that is not the department selector is conditional.
    var conditional = fields.filter(function (f) {
      return f !== departmentField;
    });

    function setHidden(el, hidden) {
      if (!el) return;
      el.hidden = hidden;
      // A hidden required field blocks submission in every browser, so the
      // required flag has to move with visibility.
      var input = el.querySelector('input, select, textarea');
      if (!input) return;
      if (hidden) {
        if (input.required) {
          input.dataset.vdpsRequired = 'true';
          input.required = false;
        }
      } else if (input.dataset.vdpsRequired === 'true') {
        input.required = true;
      }
    }

    function update() {
      var chosen = select.value;
      var hasChoice = chosen !== '';

      conditional.forEach(function (f) {
        setHidden(f, !hasChoice);
      });
      if (actions) actions.hidden = !hasChoice;

      // Order number only for the departments that need it.
      if (orderWrap) {
        var wantsOrder = hasChoice && orderDepts.indexOf(chosen) !== -1;
        setHidden(orderWrap, !wantsOrder);
      }

      if (hasChoice) wrap.classList.add('is-revealed');
      else wrap.classList.remove('is-revealed');
    }

    // Mark as enhanced so CSS can animate the reveal. Without this class the
    // stylesheet leaves everything visible.
    wrap.classList.add('vdps-form--enhanced');

    select.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
